import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ClassifierLanguage1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5003 7.49998V1.49998H16.5003V7.49998H18.7503V10.5H17.2503V12H22.5003V10.5H20.2503V7.49998H22.5003ZM18.0003 2.99998H21.0003V5.99998H18.0003V2.99998ZM15.0003 17.5575L13.9428 16.5L12.0003 18.4425L10.0578 16.5L9.0003 17.5575L10.9428 19.5L9.0003 21.4425L10.0578 22.5L12.0003 20.5575L13.9428 22.5L15.0003 21.4425L13.0578 19.5L15.0003 17.5575ZM15.0003 10.5H9.0003V12H11.2503V15.75H12.7503V12H15.0003V10.5ZM5.25022 7.39497C6.71295 7.0173 7.66667 5.61088 7.47631 4.11222C7.28596 2.61356 6.01092 1.49023 4.50022 1.49023C2.98952 1.49023 1.71449 2.61356 1.52413 4.11222C1.33378 5.61088 2.28749 7.0173 3.75022 7.39497V10.5H1.50022V12H6.75022V10.5H5.25022V7.39497ZM3.0003 4.49998C3.0003 3.67156 3.67187 2.99998 4.5003 2.99998C5.32872 2.99998 6.0003 3.67156 6.0003 4.49998C6.0003 5.32841 5.32872 5.99998 4.5003 5.99998C3.67187 5.99998 3.0003 5.32841 3.0003 4.49998Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ClassifierLanguage1.vue"]]);
